import DepositInterestService from '../../services/DepositInterestService';
import swal from "sweetalert";

// Action Types
export const DEPOSIT_INTEREST_LOADING_TOGGLE = '[DepositInterest] Loading Toggle';
export const ADD_INTEREST_PAYMENT_SUCCESS = '[DepositInterest] Add Interest Payment Success';
export const ADD_INTEREST_PAYMENT_FAILED = '[DepositInterest] Add Interest Payment Failed';
export const GET_INTEREST_PAYMENTS_SUCCESS = '[DepositInterest] Get Interest Payments Success';
export const GET_INTEREST_PAYMENTS_FAILED = '[DepositInterest] Get Interest Payments Failed';
export const GET_INTEREST_PAYMENT_BY_ID_SUCCESS = '[DepositInterest] Get Interest Payment By ID Success';
export const GET_INTEREST_PAYMENT_BY_ID_FAILED = '[DepositInterest] Get Interest Payment By ID Failed';
export const GET_INTEREST_SUMMARY_SUCCESS = '[DepositInterest] Get Interest Summary Success';
export const GET_INTEREST_SUMMARY_FAILED = '[DepositInterest] Get Interest Summary Failed';
export const GET_DEPOSITORS_FOR_INTEREST_SUCCESS = '[DepositInterest] Get Depositors For Interest Success';
export const GET_DEPOSITORS_FOR_INTEREST_FAILED = '[DepositInterest] Get Depositors For Interest Failed';
export const CLEAR_DEPOSIT_INTEREST_ERRORS = '[DepositInterest] Clear Errors';
export const RESET_DEPOSIT_INTEREST_SUCCESS = '[DepositInterest] Reset Success State';

// Action Creators
export function depositInterestLoadingToggle(status) {
    return {
        type: DEPOSIT_INTEREST_LOADING_TOGGLE,
        payload: status,
    };
}

export function addInterestPaymentAction(interestData, navigate) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.addInterestPayment(interestData);
            
            if (response && response.success === true) {
                dispatch({
                    type: ADD_INTEREST_PAYMENT_SUCCESS,
                    payload: response
                });
                swal({
                    title: "Success!",
                    text: response.message || "Interest payment added successfully",
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    dispatch(resetDepositInterestSuccess());
                    if (navigate) {
                        navigate('/deposit-interest');
                    }
                });
                return Promise.resolve(response);
            } else {
                dispatch({
                    type: ADD_INTEREST_PAYMENT_FAILED,
                    payload: response.message || 'Failed to add interest payment'
                });
                swal({
                    title: "Error!",
                    text: response.message || "Failed to add interest payment",
                    icon: "error",
                    buttons: true
                });
                return Promise.reject(response);
            }
        } catch (error) {
            dispatch({
                type: ADD_INTEREST_PAYMENT_FAILED,
                payload: error.response?.data?.message || 'Failed to add interest payment'
            });
            swal({
                title: "Error!",
                text: error.response?.data?.message || 'Failed to add interest payment',
                icon: "error",
                buttons: true
            });
            return Promise.reject(error);
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getInterestPaymentsAction(params = {}) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getAllInterestPayments(params);
            dispatch({
                type: GET_INTEREST_PAYMENTS_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_INTEREST_PAYMENTS_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest payments'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getInterestPaymentByIdAction(id) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getInterestPaymentById(id);
            dispatch({
                type: GET_INTEREST_PAYMENT_BY_ID_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_INTEREST_PAYMENT_BY_ID_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest payment'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getInterestSummaryAction(params = {}) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getInterestSummary(params);
            dispatch({
                type: GET_INTEREST_SUMMARY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_INTEREST_SUMMARY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest summary'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function getDepositorsForInterestAction(branchId) {
    return async (dispatch) => {
        dispatch(depositInterestLoadingToggle(true));
        try {
            const response = await DepositInterestService.getDepositorsForInterest(branchId);
            dispatch({
                type: GET_DEPOSITORS_FOR_INTEREST_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITORS_FOR_INTEREST_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch depositors'
            });
        } finally {
            dispatch(depositInterestLoadingToggle(false));
        }
    };
}

export function clearDepositInterestErrors() {
    return {
        type: CLEAR_DEPOSIT_INTEREST_ERRORS
    };
}

export function resetDepositInterestSuccess() {
    return {
        type: RESET_DEPOSIT_INTEREST_SUCCESS
    };
}